import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integer-date-operator',
  templateUrl: './integer-date.component.html',
  styleUrls: ['./integer-date.component.css']
})
export class IntegerDateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}